<template>
    <section :id="component.identifier ? component.identifier : ''"  class="mb-64 site__container" v-if="show">
        <component-header :title="title" :description="description"></component-header>

        <play-video :url="videoUrl"></play-video>
    </section>
</template>

<script>
import { mapState } from 'pinia';
import { useCommonStore } from '../../state/common';
import { useBrandingStore } from '../../state/branding';
import ComponentHeader from './ComponentHeader.vue';
import PlayVideo from './PlayVideo.vue';
import { videoPlayer } from '../../../app/mixins/videoPlayer';
import { runningInBrowser } from '../../helpers';

export default {
    components: {
        'component-header': ComponentHeader,
        'play-video': PlayVideo,
    },
    mixins: [videoPlayer()],
    props: {
        component: {
            required: true,
        }
    },
    data: function () {
        return {
            videoUrl: '',
        }
    },
    computed: {
        ...mapState(useCommonStore, ['locale']),
        ...mapState(useBrandingStore, ['brandHex']),
        show () {
            return runningInBrowser() || this.hasContent;
        },
        hasContent () {
            return !!this.videoUrl;
        },
        title: {
            get () {
                return this.translated(this.component.title);
            }
        },
        description: {
            get () {
                return this.translated(this.component.description);
            }
        }
    },
    methods: {
        getUrl () {
            if (this.component.translated_url.hasOwnProperty(this.locale) &&
                this.validateVideo(this.component.translated_url[this.locale]))  {
                return this.embedVideo(this.component.translated_url[this.locale]);
            } else if (this.validateVideo(this.component.url)) {
                return this.embedVideo(this.component.url);
            }

            return null;
        }
    },
    created () {
        this.videoUrl = this.getUrl();
    },
    mounted () {
        this.$emit('loaded');
    }
}
</script>

<style scoped>

</style>
